import './style/reset.css';
import './style';
import App from './components/app';

export default App;
